export const KEYCLOAK_AUTH_URLS = {
    INT: 'https://business-auth.int.odm.bmw-fleet.net/auth',
    PROD: 'https://business-auth.prod.odm.bmw-fleet.net/auth'
};

export const KEYCLOAK_REALM = 'ODM';
